import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Info } from 'lucide-react';
import { metricDisplay } from '../Analytics/components/MetricValue';
import type { OverviewMetric } from '../Analytics/overviewTypes';

export const pupilCheckinLabel = 'Pupil AI literacy (check-in)';
export const checkinInfo = "Each teacher runs a show of hands with one class at the start and end of the year. This is the average change across six statements, in percentage points. Reversed statements count a fall as an improvement. 'Used AI for schoolwork' is shown for context only and not counted.";
export const groupMeasureLabel = (measure: string) => measure === 'Class check-in average change' ? pupilCheckinLabel : measure;

export function groupMetricDisplay(metric: OverviewMetric | null, signed = false): string {
  if (!metric || metric.status !== 'ready' || metric.value === null || metric.unit !== 'pp') return metricDisplay(metric);
  const value = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 }).format(Math.abs(metric.value));
  const sign = value === '0' ? '' : metric.value < 0 ? '−' : signed ? '+' : '';
  return `${sign}${value}pp`;
}

export default function GroupMetricValue({ metric, signed = false }: { metric: OverviewMetric | null; signed?: boolean }) {
  return <span>{groupMetricDisplay(metric, signed)}</span>;
}

export function CheckinInfo() {
  return <Popover className="inline-block align-middle"><PopoverButton type="button" aria-label="About pupil AI literacy" className="rounded p-1 text-pd-slate focus-visible:outline focus-visible:outline-2"><Info size={16} aria-hidden="true" /></PopoverButton><PopoverPanel anchor="bottom end" className="z-[60] w-72 max-w-[calc(100vw-2rem)] rounded-lg border border-pd-rule bg-pd-white p-3 text-left text-xs font-normal leading-relaxed text-pd-ink shadow-lg [--anchor-gap:0.5rem]"><p role="note">{checkinInfo}</p></PopoverPanel></Popover>;
}
